import { useRef } from 'react';
import cn from 'classnames';
import styles from './babies.module.scss';
import { BabiesProps } from './babies.props';

import { ageOptions } from 'utils/constants/ageOptions.constants';
import { Portal } from 'components/other/portal/Portal';
import { Dropdown } from 'components/layout/dropdown/Dropdown';
import { Select } from 'components/forms/select/Select';

export const Babies = ({
  isOpen,
  onClick,
  onOutsideOrConfirmClick,
  onSetBaby,
  babies,
  className,
}: BabiesProps): JSX.Element => {
  const faceRef = useRef<HTMLDivElement>(null);

  const moduleStyles = cn(styles.module, className);

  return (
    <>
      <div className={moduleStyles} ref={faceRef} onClick={onClick}>
        <span>Возраст детей</span>
        <strong>
          {babies.filter((_, idx) => idx < 5).join(', ')}
          {babies.length > 5 && ', ...'}
        </strong>
      </div>
      {isOpen && (
        <Portal>
          <Dropdown
            faceRef={faceRef}
            onOutsideClick={onOutsideOrConfirmClick}
            position="bottomLeft"
          >
            <div className={styles.dropdown}>
              <div className={styles.list}>
                {babies.map((item, idx) => (
                  <div className={styles.item} key={idx}>
                    <span className={styles.name}>Ребенок {idx + 1}</span>
                    <Select
                      className={styles.select}
                      options={ageOptions}
                      value={item}
                      onChange={(event) => onSetBaby(idx, +event.target.value)}
                    />
                  </div>
                ))}
              </div>
              <button
                className={styles.button}
                onClick={onOutsideOrConfirmClick}
              >
                <span>Готово</span>
              </button>
            </div>
          </Dropdown>
        </Portal>
      )}
    </>
  );
};
